import {BusEvent, Dispatcher, DispatcherPriority, EventBus} from 'dispatcher'
import {
  DIRECT_MESSAGE_TYPE,
  WS_CHAT_TYPE_VALUE,
  WS_DIRECT_MESSAGE_RECEIVE_DATA
} from 'ws'

export class ChatMessageDispatcher extends Dispatcher<
  WS_DIRECT_MESSAGE_RECEIVE_DATA,
  undefined
> {
  protected consumable: boolean = false

  protected criteria(
    event: BusEvent<WS_DIRECT_MESSAGE_RECEIVE_DATA, undefined>
  ): boolean {
    return (
      event.type === WS_CHAT_TYPE_VALUE &&
      event.data!.type === DIRECT_MESSAGE_TYPE
    )
  }

  protected priority: DispatcherPriority = 'HIGH'

  constructor(protected eventBus: EventBus) {
    super(eventBus)
  }
}
